module.exports = __webpack_public_path__ + "img/trip(10).525b361d.webp";